export interface Character {
  name: string;
  actor: string;
  description: string;
}

export interface Movie {
  id: string;
  title: string;
  type: "movie" | "tv";
  region: string;
  year: number;
  genres: string[];
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  releaseDate: string;
  poster: string;
  backdrop: string;
  tags: string[];
  summary: string;
  plot: string[];
  characters: Character[];
  views: number;
  updatedAt: string;
}

export const movies: Movie[] = [
  {
    id: "m1",
    title: "光影边缘",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    genres: ["剧情", "家庭"],
    rating: 8.6,
    duration: "128分钟",
    director: "周慕白",
    cast: ["陈屿", "林岚", "赵承宇", "何静"],
    releaseDate: "2024-03-15",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20movie%20poster%20of%20a%20pensive%20young%20man%20standing%20beside%20a%20rain%20streaked%20window%20at%20dusk%20with%20dramatic%20chiaroscuro%20lighting%20deep%20navy%20shadows%20and%20warm%20amber%20highlights%20subtle%20film%20grain%20minimal%20composition%20no%20text&width=600&height=900&seq=film-m1-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20old%20city%20street%20at%20blue%20hour%20wet%20cobblestone%20reflecting%20warm%20window%20light%20lonely%20silhouette%20walking%20away%20moody%20atmosphere%20deep%20blue%20and%20amber%20color%20grading%20film%20grain%20no%20text&width=1600&height=900&seq=film-m1-backdrop&orientation=landscape",
    tags: ["亲情", "救赎", "小镇"],
    summary:
      "一位返乡的摄影师在整理父亲遗物时，意外揭开小镇尘封多年的往事，在光影交错中重新理解爱与被爱的重量。",
    plot: [
      "摄影师沈言在父亲去世后回到阔别十年的南方小镇，打算处理老宅后尽快离开。然而一卷未冲洗的胶片，把镜头对准了小镇上一张张熟悉又陌生的面孔，也把沈言拽回了他一直逃避的过去。",
      "随着照片被一张张放大，沈言发现父亲晚年一直在悄悄记录镇上那些被遗忘的人：独居的修表匠、守着旧书店的寡妇、以及当年与他决裂的儿时玩伴。每一张底片背后，都是一段被时代抛下的命运。",
      "在一次社区的露天放映中，沈言把父亲的胶片投上了幕布。光影亮起的那一刻，他终于明白父亲用镜头留下的不是遗憾，而是一句迟到的道歉。影片以极其克制的叙事，讲述了一个关于和解与告别的故事。",
    ],
    characters: [
      {
        name: "沈言",
        actor: "陈屿",
        description:
          "冷静内敛的摄影师，用镜头观察世界却始终无法直视内心。返乡后逐渐卸下防备，是全片情感转折的核心。",
      },
      {
        name: "林岚",
        actor: "林岚",
        description:
          "小镇书店的经营者，也是沈言青春记忆里的重要坐标。她温和坚韧，是连接过去与现在的一把钥匙。",
      },
      {
        name: "沈父",
        actor: "赵承宇",
        description:
          "沉默寡言的老人，以胶片记录小镇众生。全片未正面出场几次，却通过遗留的影像成为情绪最浓的存在。",
      },
    ],
    views: 128400,
    updatedAt: "2024-09-18",
  },
  {
    id: "m2",
    title: "沉默证词",
    type: "movie",
    region: "中国香港",
    year: 2023,
    genres: ["悬疑", "犯罪"],
    rating: 8.2,
    duration: "134分钟",
    director: "关子健",
    cast: ["梁卓然", "苏晴", "黄启铭"],
    releaseDate: "2023-11-02",
    poster:
      "https://readdy.ai/api/search-image?query=Dark%20tense%20crime%20thriller%20movie%20poster%20of%20a%20detective%20in%20a%20long%20coat%20under%20a%20single%20streetlight%20in%20heavy%20rain%20dramatic%20low%20key%20lighting%20cool%20blue%20tones%20with%20red%20accent%20reflection%20cinematic%20film%20grain%20no%20text&width=600&height=900&seq=film-m2-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20rainy%20city%20alley%20at%20night%20with%20glowing%20neon%20signs%20and%20wet%20asphalt%20reflections%20eerie%20crime%20scene%20atmosphere%20cold%20blue%20and%20crimson%20color%20grading%20dense%20fog%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-m2-backdrop&orientation=landscape",
    tags: ["谋杀", "法庭", "反转"],
    summary:
      "一桩看似证据确凿的谋杀案，因为一名沉默的证人而彻底翻转。真相与正义之间，究竟隔着多远。",
    plot: [
      "雨夜，富商陈立勋被发现死于自己的书房，所有证据都指向他的私人助理。就在案件即将盖棺定论时，一名从未开口的目击者出现了，他的沉默让整起案件变得扑朔迷离。",
      "退休法官郑维安被请来协助复盘案情，他发现这桩案子与二十年前另一宗悬案有着惊人的相似。随着调查深入，当年的受害者、如今的证人，以及坐在被告席上的人，命运早已悄悄缠绕在一起。",
      "当最后一块拼图落位，所谓的确凿证据轰然崩塌。影片没有给出轻松的答案，而是把问题抛回给观众：当程序正义与实质正义发生冲突，我们该如何选择。",
    ],
    characters: [
      {
        name: "郑维安",
        actor: "梁卓然",
        description:
          "退休法官，习惯用逻辑审视一切。越是接近真相，越发现法律条文之外还有更复杂的人性。",
      },
      {
        name: "苏晴",
        actor: "苏晴",
        description:
          "年轻的检察官，理想主义且固执，是推动案件重审的关键力量。",
      },
      {
        name: "神秘证人",
        actor: "黄启铭",
        description:
          "整部影片最核心的悬念。他的每一次沉默都成为情节推进的支点。",
      },
    ],
    views: 96200,
    updatedAt: "2024-08-30",
  },
  {
    id: "m3",
    title: "星海孤帆",
    type: "movie",
    region: "美国",
    year: 2024,
    genres: ["科幻", "冒险"],
    rating: 8.9,
    duration: "146分钟",
    director: "艾略特·格兰特",
    cast: ["诺亚·贝内特", "伊莎贝尔·雷诺", "马库斯·李"],
    releaseDate: "2024-06-21",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20sci%20fi%20space%20movie%20poster%20of%20a%20lone%20astronaut%20in%20a%20detailed%20suit%20floating%20before%20a%20giant%20ringed%20planet%20deep%20blue%20and%20teal%20nebula%20starlight%20reflections%20on%20helmet%20visually%20stunning%20cinematic%20no%20text&width=600&height=900&seq=film-m3-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20deep%20space%20scene%20with%20a%20small%20lone%20spacecraft%20sailing%20past%20a%20colossal%20glowing%20ringed%20planet%20dense%20star%20field%20and%20blue%20nebula%20clouds%20sense%20of%20scale%20and%20solitude%20cinematic%20sci%20fi%20no%20text&width=1600&height=900&seq=film-m3-backdrop&orientation=landscape",
    tags: ["太空", "生存", "孤独"],
    summary:
      "一艘失联的深空探测船，一名在宇宙中独自航行的宇航员，一场关乎人类命运的孤独抉择。",
    plot: [
      "深空探测船「孤帆号」在完成最后一次跳跃后与地球失联，船上只剩下一名宇航员艾娃。她必须在燃料、氧气与通讯全部濒临极限的情况下，独自完成一段本应由全船人共同完成的航程。",
      "航行途中，艾娃接收到一段来历不明的信号。信号里是她失踪多年的搭档的声音，也可能是深空中某种事物精心编织的诱饵。她一边试图确定信号真伪，一边不断回放过去的任务日志，拼凑出当年任务的真相。",
      "当飞船终于抵达目的地，艾娃面对的是一个远超预期的宏大景象，以及一个必须独自做出的选择。影片用极简的场景与极致的视觉，讲述了一个关于孤独、信任与人类勇气的故事。",
    ],
    characters: [
      {
        name: "艾娃·诺兰",
        actor: "伊莎贝尔·雷诺",
        description:
          "深空探测任务唯一幸存的宇航员，冷静专业却背负着沉重的心结，她的孤独是整部影片的情绪底色。",
      },
      {
        name: "达尼尔",
        actor: "诺亚·贝内特",
        description:
          "艾娃失踪的搭档，只存在于日志与信号之中，却时刻牵动着剧情走向。",
      },
      {
        name: "船载系统 K",
        actor: "马库斯·李",
        description:
          "孤帆号的人工智能，是艾娃唯一的对话者，也是她理性与情感之间的缓冲地带。",
      },
    ],
    views: 215600,
    updatedAt: "2024-09-25",
  },
  {
    id: "m4",
    title: "长夜将尽",
    type: "movie",
    region: "英国",
    year: 2022,
    genres: ["剧情", "历史"],
    rating: 7.9,
    duration: "141分钟",
    director: "艾米莉亚·克劳馥",
    cast: ["托马斯·韦恩", "海伦·卡特", "乔舒亚·布莱克"],
    releaseDate: "2022-10-14",
    poster:
      "https://readdy.ai/api/search-image?query=Period%20drama%20movie%20poster%20of%20a%20weary%20scholar%20holding%20a%20candle%20in%20a%20vast%20stone%20library%20at%20night%20warm%20candlelight%20against%20cold%20shadow%20elegant%20muted%20palette%20with%20deep%20blue%20tones%20cinematic%20detail%20no%20text&width=600&height=900&seq=film-m4-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Historic%20cobblestone%20square%20of%20an%20old%20European%20city%20at%20dusk%20with%20gas%20lamps%20catching%20warm%20light%20against%20a%20deep%20blue%20evening%20sky%20solemn%20period%20atmosphere%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-m4-backdrop&orientation=landscape",
    tags: ["战争", "知识分子", "抉择"],
    summary:
      "在战火蔓延的长夜里，一位历史学者用一支笔和一段记忆，守护着一座城市最后的尊严。",
    plot: [
      "故事发生在一座被围困的欧洲古城。历史学者汉斯在炮火声中坚持整理城市的档案，他相信只要记忆还在，这座城市就不会真正消失。",
      "随着物资与希望一同告急，汉斯被迫在保存档案与保护身边人之间做出取舍。他的学生、邻居和昔日对手，在这场漫长的对峙中各自展现出人性最真实的一面。",
      "当停战的钟声终于在黎明前响起，汉斯却发现有些东西再也无法复原。影片以庄重克制的影像语言，探讨了记忆、文明与牺牲之间的关系。",
    ],
    characters: [
      {
        name: "汉斯·里德",
        actor: "托马斯·韦恩",
        description:
          "固执而温和的历史学者，他把档案看得比生命更重，却在过程中逐渐理解了更重要的东西。",
      },
      {
        name: "海伦",
        actor: "海伦·卡特",
        description:
          "汉斯的学生，务实而勇敢，是乱世中理性与希望的代表。",
      },
      {
        name: "布莱克上校",
        actor: "乔舒亚·布莱克",
        description:
          "负责城防的军官，与汉斯立场对立却彼此尊重，是影片张力的重要来源。",
      },
    ],
    views: 64800,
    updatedAt: "2024-05-12",
  },
  {
    id: "m5",
    title: "猎风者",
    type: "movie",
    region: "中国大陆",
    year: 2023,
    genres: ["动作", "冒险"],
    rating: 7.5,
    duration: "122分钟",
    director: "武岳",
    cast: ["高鹏", "沈一诺", "雷震"],
    releaseDate: "2023-07-08",
    poster:
      "https://readdy.ai/api/search-image?query=Dynamic%20action%20adventure%20movie%20poster%20of%20a%20rugged%20lone%20rider%20on%20a%20motorcycle%20speeding%20across%20a%20windswept%20desert%20highway%20at%20sunset%20dust%20and%20motion%20blur%20warm%20orange%20and%20deep%20blue%20contrast%20cinematic%20no%20text&width=600&height=900&seq=film-m5-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20dusty%20desert%20highway%20under%20a%20huge%20orange%20sunset%20sky%20with%20a%20single%20rider%20silhouette%20racing%20into%20the%20distance%20speed%20and%20freedom%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-m5-backdrop&orientation=landscape",
    tags: ["寻人", "公路", "热血"],
    summary:
      "为了寻找失踪的妹妹，一名退役车手重操旧业，沿着一条横穿荒野的公路，追击着一个隐藏多年的秘密。",
    plot: [
      "退役越野车手陈锋在妹妹离奇失踪后，收到了她留下的最后一段定位记录。唯一的线索，是一条被废弃多年的西部公路。",
      "一路上，陈锋遇到形形色色的过客：加油站的老人、居心叵测的车队、以及一个似乎知道内情的女孩。速度与危险如影随形，他必须在引擎的轰鸣声中分辨谁在说谎。",
      "当他终于抵达公路的尽头，等待他的不是妹妹，而是一个足以颠覆他对整个家庭认知的真相。影片用凌厉的镜头与热血的节奏，完成了一场关于执念与放下的追击。",
    ],
    characters: [
      {
        name: "陈锋",
        actor: "高鹏",
        description:
          "沉默寡言的退役车手，责任感极强。他把寻找妹妹当作唯一的执念，也因此不断逼近自己的极限。",
      },
      {
        name: "小满",
        actor: "沈一诺",
        description:
          "途中偶遇的神秘女孩，掌握着关键线索，性格机敏而倔强。",
      },
      {
        name: "雷震",
        actor: "雷震",
        description:
          "车队的头目，亦正亦邪，是陈锋追查路上最大的阻碍。",
      },
    ],
    views: 88700,
    updatedAt: "2024-04-20",
  },
  {
    id: "m6",
    title: "记忆碎片馆",
    type: "movie",
    region: "日本",
    year: 2024,
    genres: ["科幻", "悬疑"],
    rating: 8.4,
    duration: "118分钟",
    director: "白石凉介",
    cast: ["佐藤凉", "中村茜", "小林大树"],
    releaseDate: "2024-02-09",
    poster:
      "https://readdy.ai/api/search-image?query=Surreal%20sci%20fi%20mystery%20movie%20poster%20of%20a%20person%20whose%20face%20dissolves%20into%20floating%20photographs%20against%20a%20deep%20teal%20background%20dreamlike%20and%20eerie%20soft%20glow%20delicate%20particles%20cinematic%20no%20text&width=600&height=900&seq=film-m6-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20surreal%20archive%20room%20filled%20with%20floating%20glowing%20memory%20fragments%20and%20photographs%20in%20a%20deep%20teal%20dreamlike%20void%20soft%20volumetric%20light%20cinematic%20sci%20fi%20no%20text&width=1600&height=900&seq=film-m6-backdrop&orientation=landscape",
    tags: ["记忆", "反转", "伦理"],
    summary:
      "在可以借阅他人记忆的博物馆里，一名修复师发现了一段不该存在的记忆，也发现了自己身份的裂痕。",
    plot: [
      "近未来，人类发明了可以提取与储存记忆的技术。「记忆碎片馆」成了一座收藏着无数人生片段的特殊博物馆，修复师翔太的工作，就是修补那些损坏的记忆胶片。",
      "一天，翔太在修复一段匿名记忆时，看到了一个与自己一模一样的背影。这段记忆不属于任何一位登记在册的捐赠者，仿佛凭空出现。为了查明真相，他开始违规调阅馆内的隐秘档案。",
      "越接近答案，翔太越难以分辨自己究竟是谁。影片以精巧的结构与冷冽的美学，抛出一个关于身份与真实性的哲学命题。",
    ],
    characters: [
      {
        name: "翔太",
        actor: "佐藤凉",
        description:
          "记忆修复师，冷静细致。当他开始怀疑自己的记忆，理性也成了他最不可靠的工具。",
      },
      {
        name: "茜",
        actor: "中村茜",
        description:
          "博物馆的档案管理员，是翔太唯一可以信任的人，她的立场却始终暧昧不明。",
      },
      {
        name: "小林博士",
        actor: "小林大树",
        description:
          "记忆技术的奠基人，他的过往正是整起谜题的核心。",
      },
    ],
    views: 102300,
    updatedAt: "2024-09-08",
  },
  {
    id: "m7",
    title: "山与海之间",
    type: "movie",
    region: "法国",
    year: 2021,
    genres: ["爱情", "剧情"],
    rating: 8.0,
    duration: "115分钟",
    director: "克莱尔·杜邦",
    cast: ["路易·马尔尚", "艾玛·勒费弗", "皮埃尔·罗"],
    releaseDate: "2021-09-24",
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20romantic%20drama%20movie%20poster%20of%20two%20figures%20standing%20far%20apart%20on%20a%20misty%20coastline%20at%20dawn%20soft%20pastel%20sky%20with%20muted%20blue%20sea%20delicate%20melancholic%20mood%20cinematic%20no%20text&width=600&height=900&seq=film-m7-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20coastal%20village%20at%20dawn%20where%20mountains%20meet%20the%20sea%20soft%20mist%20and%20gentle%20waves%20muted%20blue%20and%20cream%20tones%20peaceful%20melancholic%20atmosphere%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-m7-backdrop&orientation=landscape",
    tags: ["异地", "书信", "等待"],
    summary:
      "一个住在山里，一个住在海边，两个从未见过面的人通过一封封书信，慢慢走进彼此的生命。",
    plot: [
      "山间的气象观测员安托万与海边灯塔守护人的女儿艾玛，因为一次寄错的信件开始通信。他们从未见过面，却在字里行间一点点拼凑出对方的生活。",
      "四季流转，信件成了两人生活中最重要的期待。可越是了解彼此，他们越害怕让现实打破这份完美的想象。见面的约定一次次被推迟。",
      "多年以后，当他们终于站在山与海的交界处，才发现有些相遇早已超越了时间与距离。影片以书信体的结构，书写了一段温柔而克制的爱情。",
    ],
    characters: [
      {
        name: "安托万",
        actor: "路易·马尔尚",
        description:
          "坚守山顶观测站的观测员，习惯独处，却因一封信打开了封闭多年的内心。",
      },
      {
        name: "艾玛",
        actor: "艾玛·勒费弗",
        description:
          "灯塔守夜人的女儿，温柔又倔强，用文字编织出一个属于自己的世界。",
      },
      {
        name: "皮埃尔",
        actor: "皮埃尔·罗",
        description:
          "山间邮递员，是连接山里与海边的那根看不见的线。",
      },
    ],
    views: 47900,
    updatedAt: "2024-03-02",
  },
  {
    id: "t1",
    title: "深巷谜案",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["悬疑", "犯罪"],
    rating: 9.0,
    duration: "全24集",
    director: "韩之遥",
    cast: ["秦川", "白露", "顾言", "徐峰"],
    releaseDate: "2024-05-18",
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20mystery%20TV%20series%20poster%20of%20a%20detective%20silhouette%20walking%20through%20a%20narrow%20lantern%20lit%20old%20alley%20at%20night%20mist%20and%20deep%20shadows%20cool%20blue%20tones%20with%20warm%20lantern%20glow%20cinematic%20no%20text&width=600&height=900&seq=film-t1-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Old%20Chinese%20town%20alley%20at%20night%20with%20red%20lanterns%20dimly%20lit%20windows%20and%20drifting%20fog%20mysterious%20atmosphere%20deep%20blue%20shadows%20and%20warm%20accents%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-t1-backdrop&orientation=landscape",
    tags: ["连环案", "刑侦", "人性"],
    summary:
      "老城区接连发生的离奇案件，都指向一条几乎被城市遗忘的老巷。刑警队长与法医联手，走进这条深巷，也走进人心的暗处。",
    plot: [
      "老城区一条即将拆迁的巷子里，接连出现几具身份不明的遗体。现场没有任何打斗痕迹，只有一只被摆正的老式怀表。刑警队长秦川敏锐地察觉到，这些案件之间存在着某种仪式般的内在联系。",
      "随着调查推进，指向逐渐汇聚到二十年前一桩被草草结案的旧案上。当年的相关人员如今散落各处，有人身居高位，有人隐姓埋名，而他们与这条深巷都有着说不清的关系。",
      "当真相逐步浮出水面，秦川发现凶手要寻找的并非复仇，而是一个迟到的公道。全剧在悬念迭起的侦破过程中，层层剥开人性在欲望与良知之间的挣扎。",
    ],
    characters: [
      {
        name: "秦川",
        actor: "秦川",
        description:
          "刑警队长，直觉敏锐且执着。他坚信案件背后必有逻辑，却一次次被人心的复杂打乱节奏。",
      },
      {
        name: "白露",
        actor: "白露",
        description:
          "法医，冷静理性，是案件细节的关键解读者。她与秦川的默契是本剧重要的情感支点。",
      },
      {
        name: "顾言",
        actor: "顾言",
        description:
          "看似无关的档案管理员，掌握着案件最关键的一页，身份成谜。",
      },
    ],
    views: 342100,
    updatedAt: "2024-09-27",
  },
  {
    id: "t2",
    title: "都市浮沉",
    type: "tv",
    region: "中国大陆",
    year: 2023,
    genres: ["都市", "职场"],
    rating: 7.8,
    duration: "全36集",
    director: "沈嘉禾",
    cast: ["江晚", "程野", "罗蜜"],
    releaseDate: "2023-08-11",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20TV%20poster%20of%20a%20confident%20young%20professional%20woman%20standing%20before%20a%20towering%20glass%20skyscraper%20at%20dusk%20cool%20blue%20reflections%20and%20warm%20window%20lights%20cinematic%20no%20text&width=600&height=900&seq=film-t2-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20city%20skyline%20of%20a%20modern%20metropolis%20with%20countless%20lit%20windows%20deep%20blue%20twilight%20sky%20and%20warm%20amber%20lights%20sense%20of%20ambition%20and%20loneliness%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-t2-backdrop&orientation=landscape",
    tags: ["职场", "成长", "现实"],
    summary:
      "三个背景迥异的年轻人闯入同一家跨国企业，在光鲜的写字楼里，经历理想的碰撞、欲望的诱惑与友情的考验。",
    plot: [
      "名校毕业的江晚、草根出身的程野、海归千金罗蜜，因为一次实习计划进入同一家跨国公司的核心部门。他们以为拿到了通往成功的门票，却一头撞进了复杂的职场丛林。",
      "为了争取一个晋升名额，三人不得不在合作与竞争之间反复权衡。江晚发现努力并不总能换来公平，程野在原则与生存之间摇摆，而罗蜜则要面对家庭安排在暗处的牵扯。",
      "在一场几乎摧毁职业生涯的商业风波后，三人才真正明白什么叫并肩作战。剧集以真实的职场细节，描绘了年轻人在都市浮沉中的成长与坚守。",
    ],
    characters: [
      {
        name: "江晚",
        actor: "江晚",
        description:
          "名校毕业的职场新人，能力出众却过于理想主义。她经历了从天真到成熟的重要转变。",
      },
      {
        name: "程野",
        actor: "程野",
        description:
          "草根出身的实习生，圆滑仗义。他在利益与友情之间的选择，是剧中最大的看点之一。",
      },
      {
        name: "罗蜜",
        actor: "罗蜜",
        description:
          "出身优渥的海归，看似无忧实则背负家族期待，她用努力证明自己不只是标签。",
      },
    ],
    views: 156800,
    updatedAt: "2024-07-15",
  },
  {
    id: "t3",
    title: "山海迷航",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["奇幻", "冒险"],
    rating: 8.3,
    duration: "全40集",
    director: "风烬",
    cast: ["陆离", "苏晚", "鹤鸣"],
    releaseDate: "2024-04-06",
    poster:
      "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20TV%20poster%20of%20a%20traveler%20with%20a%20glowing%20compass%20standing%20at%20the%20edge%20of%20a%20celestial%20sea%20beneath%20floating%20mountains%20teal%20and%20deep%20blue%20magical%20atmosphere%20soft%20glow%20cinematic%20no%20text&width=600&height=900&seq=film-t3-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20landscape%20with%20floating%20mountains%20above%20a%20vast%20luminous%20sea%20teal%20blue%20mists%20and%20golden%20light%20beams%20sense%20of%20wonder%20and%20adventure%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-t3-backdrop&orientation=landscape",
    tags: ["奇幻", "寻宝", "东方美学"],
    summary:
      "一枚会指向心之所向的古老罗盘，带着四名身份各异的旅人，驶向传说中藏在山海深处的秘境。",
    plot: [
      "少年陆离意外得到一枚古老的罗盘，罗盘的指针不指向北，而指向持有者内心最渴望的东西。为了寻找失踪的师父，他踏上了一次穿越山海的航程。",
      "同行的还有身世神秘的女祭司苏晚、自称见多识广的商人鹤鸣，以及一只会说人话的灵兽。四人各怀目的，却在一次次险境中逐渐结成真正的队伍。",
      "随着秘境临近，罗盘指向的真相却愈发扑朔迷离。剧集以东方奇幻的独特美学，构建了一个瑰丽山海与人心迷宫交织的世界。",
    ],
    characters: [
      {
        name: "陆离",
        actor: "陆离",
        description:
          "单纯倔强的少年，因罗盘踏上旅程。他的成长贯穿全剧，是东方少年英雄的典型写照。",
      },
      {
        name: "苏晚",
        actor: "苏晚",
        description:
          "神秘的女祭司，掌握着秘境的关键秘密，冷静外表下藏着复杂的过往。",
      },
      {
        name: "鹤鸣",
        actor: "鹤鸣",
        description:
          "油嘴滑舌的商人，看似贪财实则重情，是团队里最不可靠也最可靠的存在。",
      },
    ],
    views: 198400,
    updatedAt: "2024-09-12",
  },
  {
    id: "t4",
    title: "平行来信",
    type: "tv",
    region: "韩国",
    year: 2023,
    genres: ["科幻", "悬疑"],
    rating: 8.7,
    duration: "全16集",
    director: "郑在勋",
    cast: ["李瑞贤", "韩宥真", "朴度允"],
    releaseDate: "2023-12-15",
    poster:
      "https://readdy.ai/api/search-image?query=Sci%20fi%20mystery%20TV%20poster%20of%20a%20woman%20holding%20an%20envelope%20that%20glows%20faintly%20in%20a%20dim%20room%20with%20deep%20teal%20shadows%20and%20cool%20blue%20light%20eerie%20atmosphere%20cinematic%20no%20text&width=600&height=900&seq=film-t4-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Two%20parallel%20versions%20of%20the%20same%20rainy%20city%20street%20mirrored%20and%20split%20by%20a%20glowing%20seam%20of%20light%20deep%20teal%20and%20cold%20blue%20palette%20surreal%20sci%20fi%20atmosphere%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-t4-backdrop&orientation=landscape",
    tags: ["平行世界", "悬疑", "救赎"],
    summary:
      "一封来自另一个平行世界的信，让一名普通教师发现，自己所处的世界或许只是无数可能性中的一个。",
    plot: [
      "中学教师李瑞贤在搬家时，从旧墙夹层里找到一封字迹熟悉的信。信是「另一个自己」写来的，来自一个与她所在世界略有不同的平行时空。",
      "起初她以为这只是恶作剧，可信里预言的事情接连应验。为了弄清真相，她开始尝试回信，两个世界的界限因此被一点点打破。",
      "随着交流深入，瑞贤发现另一个世界的自己正身处危机，而她的每一次回信都在悄然改变着两个世界的命运。剧集以缜密的逻辑与细腻的情感，讲述了一个关于选择与救赎的故事。",
    ],
    characters: [
      {
        name: "李瑞贤",
        actor: "李瑞贤",
        description:
          "平凡的中学教师，冷静又好奇。与平行自我的通信，迫使她重新审视自己的人生选择。",
      },
      {
        name: "韩宥真",
        actor: "韩宥真",
        description:
          "另一位世界的瑞贤，身处困境却始终坚强，她与主角的对照是剧集最重要的结构。",
      },
      {
        name: "朴度允",
        actor: "朴度允",
        description:
          "研究者，最早提出平行通信理论的人，也是这条线索上最关键也最危险的知情者。",
      },
    ],
    views: 231700,
    updatedAt: "2024-08-22",
  },
  {
    id: "t5",
    title: "江湖夜雨",
    type: "tv",
    region: "中国大陆",
    year: 2022,
    genres: ["古装", "武侠"],
    rating: 8.1,
    duration: "全45集",
    director: "韦青衫",
    cast: ["谢云归", "宁素心", "柳惊鸿"],
    releaseDate: "2022-11-20",
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20period%20TV%20poster%20of%20a%20swordsman%20standing%20in%20falling%20rain%20under%20a%20paper%20lantern%20with%20an%20ancient%20sword%20deep%20blue%20night%20and%20warm%20lantern%20glow%20ink%20wash%20atmosphere%20cinematic%20no%20text&width=600&height=900&seq=film-t5-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20town%20rooftops%20under%20heavy%20night%20rain%20with%20lit%20paper%20lanterns%20and%20distant%20mountains%20deep%20blue%20ink%20wash%20tones%20with%20warm%20lantern%20accents%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-t5-backdrop&orientation=landscape",
    tags: ["武侠", "江湖", "恩怨"],
    summary:
      "一位隐姓埋名的剑客重出江湖，只为查清当年师门覆灭的真相。刀光剑影之间，情义与仇恨都已说不清。",
    plot: [
      "江湖传言，十年前覆灭的「听雨剑阁」尚有传人存活。隐居于小镇酒肆的谢云归被迫重出江湖，因为一张突然出现的旧日名帖，牵出了当年灭门的线索。",
      "一路上，他结识了身怀秘密的医女宁素心与亦敌亦友的剑客柳惊鸿。三人之间既有肝胆相照，也有难以言说的猜防。",
      "当真相揭开，谢云归发现仇人正是当年最信任的人。江湖夜雨之中，他必须回答一个问题：复仇之后，人还能剩下什么。剧集以写意的武打与厚重的情义，重塑了武侠的浪漫与苍凉。",
    ],
    characters: [
      {
        name: "谢云归",
        actor: "谢云归",
        description:
          "隐姓埋名的剑客，剑法极高却心怀愧疚。他重出江湖的动机是全剧的核心主线。",
      },
      {
        name: "宁素心",
        actor: "宁素心",
        description:
          "医术高明而身世成谜的女子，她的出现让谢云归的复仇之路充满变数。",
      },
      {
        name: "柳惊鸿",
        actor: "柳惊鸿",
        description:
          "潇洒不羁的剑客，与谢云归惺惺相惜又立场对立，是剧中极具魅力的人物。",
      },
    ],
    views: 174300,
    updatedAt: "2024-06-10",
  },
  {
    id: "t6",
    title: "白色回廊",
    type: "tv",
    region: "日本",
    year: 2023,
    genres: ["医疗", "剧情"],
    rating: 8.5,
    duration: "全11集",
    director: "高梨真司",
    cast: ["藤井悠", "佐仓绫", "田边拓"],
    releaseDate: "2023-10-09",
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20TV%20poster%20of%20a%20doctor%20in%20a%20long%20white%20coat%20standing%20in%20a%20bright%20hospital%20corridor%20soft%20cool%20daylight%20clean%20minimal%20composition%20with%20pale%20blue%20tones%20cinematic%20no%20text&width=600&height=900&seq=film-t6-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Clean%20minimal%20hospital%20corridor%20bathed%20in%20soft%20cool%20daylight%20long%20perspective%20and%20quiet%20atmosphere%20pale%20blue%20and%20white%20palette%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-t6-backdrop&orientation=landscape",
    tags: ["医疗", "医患", "成长"],
    summary:
      "在一间以严谨著称的医院里，一名理想主义的年轻医生，必须在制度与生命之间找到属于自己的答案。",
    plot: [
      "年轻医生藤井悠入职了以严格制度闻名的白洋医院。她怀揣着救死扶伤的理想，却很快发现，真正难倒她的往往不是疾病，而是制度与人情。",
      "在资深护士佐仓绫与外科主任田边拓的影响下，藤井悠开始理解医院这座白色回廊里复杂的运作逻辑。每一次查房、每一台手术，都是一次关于责任的考验。",
      "当一场突发的公共医疗事件降临，医院上下不得不重新审视那些看似牢不可破的规则。剧集以克制细腻的笔触，呈现了医疗现场的紧张与人性的温度。",
    ],
    characters: [
      {
        name: "藤井悠",
        actor: "藤井悠",
        description:
          "充满理想的年轻医生，从天真到成熟，她的成长线是全剧的情感主干。",
      },
      {
        name: "佐仓绫",
        actor: "佐仓绫",
        description:
          "经验丰富的资深护士，冷静果断，是藤井悠在医院里最坚实的依靠。",
      },
      {
        name: "田边拓",
        actor: "田边拓",
        description:
          "严谨的外科主任，看似不近人情，实则背负着沉重的手术往事。",
      },
    ],
    views: 112500,
    updatedAt: "2024-05-28",
  },
  {
    id: "t7",
    title: "火焰之城",
    type: "tv",
    region: "美国",
    year: 2024,
    genres: ["犯罪", "悬疑"],
    rating: 8.8,
    duration: "全10集",
    director: "丹尼尔·科尔",
    cast: ["伊桑·里德", "娜塔莉·格兰特", "维克多·李"],
    releaseDate: "2024-07-05",
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20TV%20poster%20of%20a%20brooding%20detective%20silhouette%20against%20a%20burning%20city%20skyline%20at%20night%20orange%20fire%20glow%20and%20deep%20blue%20smoke%20dramatic%20contrast%20cinematic%20no%20text&width=600&height=900&seq=film-t7-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20city%20skyline%20with%20orange%20fire%20glow%20and%20thick%20smoke%20rising%20against%20a%20deep%20blue%20sky%20dramatic%20emergency%20atmosphere%20cinematic%20wide%20shot%20no%20text&width=1600&height=900&seq=film-t7-backdrop&orientation=landscape",
    tags: ["纵火", "调查", "阴谋"],
    summary:
      "一连串纵火案席卷整座城市，火光背后，是一张精心编织了十年的网。有人要烧掉的，不只是建筑。",
    plot: [
      "一座繁华大都市被接连的纵火案搅得人心惶惶。每一起火灾都精准地避开人群，却指向一栋栋与同一家公司有关的建筑。警探伊桑·里德意识到，这不是随机的犯罪，而是一场缜密的清算。",
      "随着调查深入，伊桑发现线索指向十年前一场被掩盖的重大事故。当年的受害者、如今的纵火者、以及试图维稳的各方势力，在火光中逐渐显形。",
      "当最后一栋建筑燃起，伊桑必须赶在更多人被卷入之前揭开真相。剧集以高强度的节奏与冷峻的影像，讲述了一个关于遗忘与复仇的现代寓言。",
    ],
    characters: [
      {
        name: "伊桑·里德",
        actor: "伊桑·里德",
        description:
          "经验老到的警探，因旧案与这座城市有着私人恩怨。他追查纵火案的过程，也是自我和解的过程。",
      },
      {
        name: "娜塔莉·格兰特",
        actor: "娜塔莉·格兰特",
        description:
          "火灾调查专家，冷静理性，是拼凑出完整真相的关键人物。",
      },
      {
        name: "维克多·李",
        actor: "维克多·李",
        description:
          "涉事公司的高管，光鲜身份背后藏着十年前的秘密，是剧中最复杂的灰色人物。",
      },
    ],
    views: 268900,
    updatedAt: "2024-09-30",
  },
];

